export default __webpack_public_path__ + "static/edutech-asia-b2ca73b6869d9771d650373e38b04f53.png";